<app-header bannerImage="gentlemanHoldingSeedsBanner.webp"></app-header>
<ng-container *ngIf="!results" >
<h4 i18n="@@titleIntroToSeedCoating">
  New! Enhanced Services for Seed Coatings
</h4>
<p i18n="@@introToSeedCoatingPara1">
  Yara products applied as seed coatings have proved to be a important way of
  enhancing the value of seeds. Due to the surge of interest, we have
  added the seed treatment product development process to this website. It is
  now quick and easy to get a potential seed coating developed and tested.
  <a [routerLink]="['/request-seed-treatment']">Find out more </a>
</p>
</ng-container>
<div *ngIf="!results">
  <h2 i18n="@@Search">Search</h2>
  <form *ngIf="!searching" [formGroup]="searchForm">
    <div class="sideBySide">
      <div>
        <div *ngIf="countryChoices" class="form-group">
          <label for="countryDropDown" i18n="@@Select your country">Select your country</label>
          <!-- <select
            id="countryDropDown"
            required
            name="countryDropDown"
           
            formControlName="countryCode"
            autocomplete="country-name"
            (change)="changeCountry()"
          >
            <option *ngFor="let choice of countryChoices" [value]="choice.id">
              {{ choice.name }}
            </option>
          </select> -->
          <select id="countryDropDown"
        required
        name="countryDropDown"
        formControlName="countryCode"
        autocomplete="country-name"
        (change)="changeCountry()">
  <option *ngFor="let choice of countryChoices" [ngValue]="choice.id">
    {{ choice.name }}
  </option>
</select>
          <small
            *ngIf="!countryChosen"
            class="form-text textmuted error"
            i18n="@@Required"
            >Required</small
          >
        </div>

        <div *ngIf="countryChosen" class="form-group">
          <!-- <label for="yaraProductDropDown">Choose a Yara Product (optional) </label>
          <select id="yaraProductDropDown" name="yaraProductDropDown"  formControlName="yaraChemicalId">
            <option *ngFor="let choice of yaraProductChoices" [value]="choice.name">{{ choice.name }}</option>
          </select> -->
          <label for="yaraChemicalId" i18n="@@Choose a Yara Product (optional)"
            >Choose a Yara Product (optional)
          </label>
          <app-nameid-typeahead
            [items]="yaraProductChoices"
            id="yaraProductCode"
            formControlName="yaraProductCode"
          ></app-nameid-typeahead>
          <small class="form-text textmuted"> </small>
          <small class="form-text textmuted"> </small>
        </div>
      </div>

      <div *ngIf="countryChosen">
        <div class="form-group">
          <label for="cropDropDown" i18n="@@choosecrop">Choose a Crop </label>
          <select
            id="cropDropDown"
            name="cropDropDown"
      
            formControlName="seedName"
          >
            <option *ngFor="let choice of cropChoices" [value]="choice.id">
              {{ choice.name }}
            </option>
          </select>
          <small class="form-text textmuted"> </small>
        </div>
      </div>
    </div>
    <br />
    <div *ngIf="countryChosen">
      <button class="btn-success" (click)="performSearch()" i18n="@@Search">
        Search
      </button>
      <button class="btn" (click)="resetSearch()" i18n="@@ResetButton">
        Reset
      </button>
    </div>
  </form>
  <div *ngIf="searching" i18n="@@Searching">Searching ......</div>
</div>
<div *ngIf="results">
  <h3 i18n="@@Search Results">Search Results</h3>
  <div *ngIf="!results.length" class="alert alert-info">
    <p i18n="@@NoTankmixResults">No Tankmix results were found.</p>
    <p>
      You may adjust your criteria, or you can ask one of our chemist to carry
      out a new test for you.
    </p>

    <a routerLink="/request">
      <button class="btn" i18n="@@requestchemicalanalysis">Request Chemical Analysis</button></a
    >
  </div>

  <div class="fullSearchResults" *ngIf="results.length">
    <button class="btn" (click)="searchAgain()" i18n="@@adjustsearchcriteria">
      Adjust Search Criteria
    </button>
    <app-seed-units-chooser></app-seed-units-chooser>

    <table class="table-yara">
      <thead>
        <tr>
          <th i18n="@@Date Tested">Date Tested</th>
         
          <th i18n="@@Products">Products</th>
          <th i18n="@@Result">Result</th>
          <th i18n="@@Donwload Report">Download Report</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tankmix of results">
          <td>{{ tankmix.dateOfTest | date }}</td>
    
          <td class="ingredientTableCell">
            <table class="ingredientTable">
              <thead>
                <tr>
                  <th class="numberColumn" i18n="@@Order">Order</th>
                  <th class="numberColumn" i18n="@@ApplicationRate">Rate</th>
                 
                  <th i18n="@@Name">Name</th>
                  <th i18n="@@Manufacturer" class="manufacturerColumn">Manufacturer</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ingredient of tankmix.ingredients">
                  <td>{{ ingredient.orderOfAddition }}</td>
                  <td>{{ convertedSeedRate(ingredient.rate) | number:'1.2'}}</td>
                 
                  <td>
                    <span *ngIf="!ingredient.products.length">{{ingredient.name}}</span>
                    <div *ngIf="ingredient.products.length">
                      <span *ngFor="let product of ingredient.products">{{ product }},</span>
                    </div>
                  </td>
                  <td>{{ ingredient.manufacturer }}</td>
                </tr>
              </tbody>
            </table>
            <span *ngIf="tankmix.observations">{{ tankmix.obserations }}</span>
          </td>
         
          <td>
            <app-result-icon [value]="tankmix.result!='NC'"></app-result-icon>
            
          </td>
          <td>
            <a href="testResult/{{ tankmix.tankmixId }}/en">
              <app-pdf-icon></app-pdf-icon>
             </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <button class="btn" (click)="searchAgain()" i18n="@@adjustsearchcriteria">
    Adjust Search Criteria
  </button>
</div>
